export const authEndpoints = {
  // --- Authentication ---
  loginUserAuth: '/public/v1/auth/login',
  logoutUserAuth: '/private/v1/auth/logout',

  initLogin: '/public/v1/auth/login/init',
  finalizeLogin: '/public/v1/auth/login/finalize',

    initRegistration: '/public/v1/auth/register/init',
  finalizeRegistration: '/public/v1/auth/register/finalize',

  // --- Registration ---
  beginUserRegistrationAuth: '/public/v1/auth/validate-otp',
  setUserPasswordAuth: '/private/v1/auth/set-password',
  verifyUserEmailAuth: '/private/v1/auth/verify-email',
  sendEmailCode: '/private/v1/auth/send-email-code',
  resendUserEmailCodeAuth: '/private/v1/auth/resend-email-code',
  confirmUserPhoneAuth: '/private/v1/auth/verify-phone',
  sendUserPhoneCodeAuth: '/private/v1/auth/send-phone-code',
  resendUserPhoneCodeAuth: '/private/v1/auth/resend-phone-code',

  // --- Two-Factor Authentication (2FA) ---
  selectUserTwoFactorMethodAuth: '/public/v1/auth/2fa/send',
  verifyUserTwoFactorCodeAuth: '/public/v1/auth/2fa/verify',
  resendUserTwoFactorCodeAuth: '/public/v1/auth/2fa/resend',

  // --- Recover Password ---
  verifyRecoveryCode: '/public/v1/auth/verify-recovery-otp',
  recoverySendTwoFactor: '/public/v1/auth/recovery/2fa/send',
  recoveryVerifyTwoFactor: '/public/v1/auth/recovery/2fa/verify',
  forgotPassword: '/public/v1/auth/forgot-password',

} as const;

